/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_Mistake_4Inputs */

const en_salary_negotiate_mistake_4 = /** @type {(inputs: Salary_Negotiate_Mistake_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Focusing only on base salary, ignoring total compensation`)
};

const de_salary_negotiate_mistake_4 = /** @type {(inputs: Salary_Negotiate_Mistake_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur auf das Grundgehalt fokussieren, Gesamtvergütung ignorieren`)
};

const fr_salary_negotiate_mistake_4 = /** @type {(inputs: Salary_Negotiate_Mistake_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se concentrer uniquement sur le salaire de base, en ignorant la rémunération totale`)
};

const es_salary_negotiate_mistake_4 = /** @type {(inputs: Salary_Negotiate_Mistake_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enfocarse solo en el salario base, ignorando la compensación total`)
};

const it_salary_negotiate_mistake_4 = /** @type {(inputs: Salary_Negotiate_Mistake_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concentrarsi solo sullo stipendio base, ignorando la retribuzione totale`)
};

const nl_salary_negotiate_mistake_4 = /** @type {(inputs: Salary_Negotiate_Mistake_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alleen focussen op basissalaris, totale vergoeding negeren`)
};

const pl_salary_negotiate_mistake_4 = /** @type {(inputs: Salary_Negotiate_Mistake_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skupianie się tylko na wynagrodzeniu podstawowym, ignorując całkowite wynagrodzenie`)
};

const fi_salary_negotiate_mistake_4 = /** @type {(inputs: Salary_Negotiate_Mistake_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vain peruspalkkaan keskittyminen, kokonaispalkitsemisen huomiotta jättäminen`)
};

const da_salary_negotiate_mistake_4 = /** @type {(inputs: Salary_Negotiate_Mistake_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kun at fokusere på grundløn og ignorere den samlede kompensation`)
};

const sv_salary_negotiate_mistake_4 = /** @type {(inputs: Salary_Negotiate_Mistake_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Att bara fokusera på grundlönen och ignorera total ersättning`)
};

/**
* | output |
* | --- |
* | "Focusing only on base salary, ignoring total compensation" |
*
* @param {Salary_Negotiate_Mistake_4Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_mistake_4 = /** @type {((inputs?: Salary_Negotiate_Mistake_4Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_Mistake_4Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_mistake_4(inputs)
	if (locale === "fr") return fr_salary_negotiate_mistake_4(inputs)
	if (locale === "es") return es_salary_negotiate_mistake_4(inputs)
	if (locale === "it") return it_salary_negotiate_mistake_4(inputs)
	if (locale === "nl") return nl_salary_negotiate_mistake_4(inputs)
	if (locale === "pl") return pl_salary_negotiate_mistake_4(inputs)
	if (locale === "fi") return fi_salary_negotiate_mistake_4(inputs)
	if (locale === "da") return da_salary_negotiate_mistake_4(inputs)
	if (locale === "sv") return sv_salary_negotiate_mistake_4(inputs)
	return en_salary_negotiate_mistake_4(inputs)
});